export const AUTH_START  = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCESS';
export const AUTH_FAIL   = 'AUTH_FAIL';
export const UPDATE_ACTIVE_CUSTOMER = 'UPDATE_ACTIVE_CUSTOMER';
export const UPDATE_ACTIVE_LANGUAGE = 'UPDATE_ACTIVE_LANGUAGE';
